import { useContext, useMemo } from 'react';
import { configurationProviderContext } from '../../components/ConfigurationProvider/ConfigurationProvider.js';
// eslint-disable-next-line sonarjs/function-return-type
export function useConfiguration(key) {
  const contextValue = useContext(configurationProviderContext);
  return useMemo(() => {
    if (Array.isArray(key)) {
      return key.reduce((accumulator, currentKey) => {
        accumulator[currentKey] = contextValue[currentKey];
        return accumulator;
      }, {});
    }
    return contextValue[key];
  }, [key, contextValue]);
}